export default __webpack_public_path__ + "static/media/rewardPointsIcon.078085d3.svg";